import type { ReactElement } from 'react'

import { ActivationFlow } from '../pages/signin/br/ActivationFlow'
import { updatePlatformHeader } from '../services/api/auth'
import { setPlatformForLogs } from '../services/datadog'

/**
 * `/signin/activation/br` — entry point for the Brazilian user **activation** funnel.
 * The whole flow is server-driven and gated by a short-lived scoped JWT stored in a
 * JS-readable `swile:activation` cookie and forwarded as `Authorization: Bearer <token>`
 * (no CSRF needed — Bearer replaces the double-submit pattern used by the main app).
 * This route just mounts the orchestrator, which resumes via `GET /signin/activation/br/state`.
 */
export const BrActivationRoute = (): ReactElement => {
  updatePlatformHeader('web')
  setPlatformForLogs('web')

  return <ActivationFlow />
}
